import $ from 'jquery';

const $element = $( '.js-reading-time' );

if ( $element.length ) {
	const text = $( '.js-reading-content' )[ 0 ].textContent;
	const wordCount = text.replace( /[^\w ]/g, '' ).split( /\s+/ ).length;
	const wpm = 250;
	let readingTimeInMinutes = 1;
	const readingTime = wordCount / wpm;
	const readingTimeModulo = readingTime - Math.floor( readingTime );

	if ( wordCount > wpm ) {
		if ( ( readingTimeModulo >= 0 ) && ( readingTimeModulo < 0.33 ) ) {
			readingTimeInMinutes = Math.floor( wordCount / wpm );
		} else if ( ( readingTimeModulo >= 0.33 ) && ( readingTimeModulo < 0.75 ) ) {
			readingTimeInMinutes = Math.floor( wordCount / wpm ) + ':30';
		} else {
			readingTimeInMinutes = Math.floor( wordCount / wpm ) + 1;
		}
	}

	$element.html( readingTimeInMinutes );
}
